// FLAGS: identity
// Issues and refreshes the per-login correlation id kept in sessionStorage; login refreshes it and
// logout removes it.
import sessionStorageService from "@src/services/sessionStorage.service";

const createUserSessionId = (forceNew = false): string => {
  if (!forceNew) {
    const existing = sessionStorageService.getUserSessionIdFromStorage();
    if (existing) return existing;
  }
  const id = crypto.randomUUID();
  sessionStorageService.saveUserSessionIdToStorage(id);
  return id;
};

export const generateUserSessionId = (): string => createUserSessionId();

// FLAGS: identity
// Called on both login branches in services/auth.service.ts, including the 2FA-pending one, so the id
// never spans two sign-ins. Skip it and one user's events keep the previous user's correlation id.
export const refreshUserSessionId = (): string => createUserSessionId(true);
